import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';


const NewTopic = ({
    form,
    currentSelectList,
    newTopic,
    onValuesChangeData,
    onDeleteTopic,
    handleError,
    setIsAddingNewTopic,
    isAddingNewTopic }) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (newTopic) {
            form.setFieldsValue({
                freeFormTitleTh: newTopic?.freeFormTitleTh || '',
                freeFormContentTh: newTopic?.freeFormContentTh || '',
                freeFormTitleEn: newTopic?.freeFormTitleEn || '',
                freeFormContentEn: newTopic?.freeFormContentEn || '',
            });
        }
    }, [newTopic, currentSelectList, form]);

    const onValuesChange = (changedValues, allValues) => {
        if (isAddingNewTopic) {
            // form.resetFields(['freeFormContentTh']);
            setIsAddingNewTopic(false);
            return;
        }
        const isTitleValid = allValues.freeFormTitleTh && allValues.freeFormTitleTh.trim() !== '';
        const isContentValid = allValues.freeFormContentTh && allValues.freeFormContentTh !== '<p><br></p>';
        if (isTitleValid && isContentValid) {
            handleError(currentSelectList, true);
        } else {
            handleError(currentSelectList, false);
        }
        onValuesChangeData(changedValues, allValues);
    };

    return (
        <>
            <Form form={form} layout="vertical" onValuesChange={onValuesChange} >
                <Form.Item
                    label={t('Title displayed in the document Th')}
                    name="freeFormTitleTh"
                    rules={[
                        {
                            required: true,
                            message: t('This field is required'),
                        },
                    ]}
                >
                    <Input
                        placeholder={t('Enter title in Thai')}
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    label={t('Content th')}
                    name="freeFormContentTh"
                    rules={
                        // !isAddingNewTopic
                        //     ? 
                        [
                                  {
                                      required: true,
                                      validator(_, value) {
                                          if (!value || value === '<p><br></p>') {
                                              return Promise.reject(new Error(t('This field is required')));
                                          }
                                          return Promise.resolve();
                                      },
                                  },
                              ]
                            // : [] 
                    }
                >
                    <Editor
                        placeholder={t('Enter content th')}
                    />
                </Form.Item>

                <Form.Item
                    label={t('Title displayed in the document En')}
                    name="freeFormTitleEn"
                >
                    <Input placeholder={t('Enter title in En')} size="large" />
                </Form.Item>


                <Form.Item label={t('Content EN')} name="freeFormContentEn">
                    <Editor
                        placeholder={t('Enter content en')}
                    />
                </Form.Item>
            </Form>
            <Button
                type="default"
                size="large"
                onClick={onDeleteTopic}
                className="border-purple text-purple px-6"
            >
                <div className="flex items-center gap-2">
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.00005 2.18332e-08C7.54895 -7.72662e-05 8.07806 0.205044 8.48348 0.575088C8.8889 0.945132 9.14135 1.45337 9.19125 2H12.6C12.7521 2.00005 12.8984 2.0578 13.0095 2.16158C13.1206 2.26536 13.1881 2.40744 13.1985 2.5591C13.2088 2.71077 13.1612 2.86071 13.0653 2.97864C12.9694 3.09656 12.8322 3.17368 12.6816 3.1944L12.6 3.2H12.1336L11.12 11.984C11.0749 12.3739 10.888 12.7336 10.5949 12.9947C10.3018 13.2558 9.92297 13.4001 9.53045 13.4H4.46965C4.07713 13.4001 3.69828 13.2558 3.40518 12.9947C3.11209 12.7336 2.92519 12.3739 2.88005 11.984L1.86565 3.2H1.40005C1.25506 3.19999 1.11498 3.14749 1.0057 3.05219C0.896433 2.95689 0.825367 2.82524 0.805649 2.6816L0.800049 2.6C0.800055 2.45501 0.852563 2.31493 0.947862 2.20566C1.04316 2.09638 1.17481 2.02532 1.31845 2.0056L1.40005 2H4.80885C4.85875 1.45337 5.11119 0.945132 5.51661 0.575088C5.92203 0.205044 6.45114 -7.72662e-05 7.00005 2.18332e-08ZM5.80005 5C5.60405 5 5.44005 5.124 5.40645 5.2872L5.40005 5.3504V10.2504L5.40645 10.3128C5.44005 10.476 5.60405 10.6 5.80005 10.6C5.99605 10.6 6.16005 10.476 6.19365 10.3128L6.20005 10.2496V5.3512L6.19365 5.2872C6.16005 5.1248 5.99605 5 5.80005 5ZM8.20005 5C8.00405 5 7.84005 5.124 7.80645 5.2872L7.80005 5.3504V10.2504L7.80645 10.3128C7.84005 10.476 8.00405 10.6 8.20005 10.6C8.39605 10.6 8.56005 10.476 8.59365 10.3128L8.60005 10.2496V5.3512L8.59365 5.2872C8.56005 5.1248 8.39605 5 8.20005 5ZM7.00005 1.2C6.51605 1.2 6.11205 1.544 6.02005 2H7.98005C7.88725 1.544 7.48405 1.2 7.00005 1.2Z"
                            fill="#7B67FB"
                        />
                    </svg>
                    <p className="mb-0">{t('Delete topic')}</p>
                </div>
            </Button>
        </>
    );
};

export default NewTopic;
